import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../api/api";

export default function BlogList() {
  const [data, setData] = useState({ blogs: [], total: 0, pages: 1 });
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      setError(null);

      try {
        // ✅ Public API, no token required
        const res = await axios.get(`/blog?page=${page}&limit=6`);
        setData(res.data);
      } catch (err) {
        console.error("Failed to load blogs:", err);
        setError("Failed to load blogs. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [page]);

  return (
    <div className="max-w-6xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6 text-center">Blog</h1>

      {loading ? (
        <div className="text-center text-gray-500">Loading blogs...</div>
      ) : error ? (
        <div className="text-center text-red-500">{error}</div>
      ) : data.blogs.length === 0 ? (
        <div className="text-center text-gray-500">No blogs found.</div>
      ) : (
        <>
          <div className="grid gap-6 md:grid-cols-2">
            {data.blogs.map((b) => (
              <Link
                key={b.id}
                to={`/blogs/${b.slug}`}
                className="bg-white rounded-lg shadow hover:shadow-lg overflow-hidden transition-shadow"
              >
                {b.coverImage && (
                  <img
                    src={b.coverImage}
                    alt={b.title}
                    className="w-full h-44 object-cover"
                  />
                )}
                <div className="p-4">
                  <h2 className="text-xl font-semibold">{b.title}</h2>
                  {b.tags && <p className="text-sm text-indigo-600">{b.tags}</p>}
                  <p className="text-xs text-gray-400 mt-2">
                    {new Date(b.publishedAt).toLocaleDateString()}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          {/* Pagination */}
          {data.pages > 1 && (
            <div className="mt-6 flex justify-center gap-2">
              {Array.from({ length: data.pages }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => setPage(i + 1)}
                  className={`px-3 py-1 border rounded ${
                    page === i + 1
                      ? "bg-indigo-600 text-white"
                      : "bg-white hover:bg-gray-50"
                  }`}
                >
                  {i + 1}
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
